<template>
  <modal :show.sync="show" modalClasses="modal-hide-footer">
    <h3 slot="header" class="mb-0">Trade References</h3>
   <div v-if="_gAuth.isAppSas() ">
    <div v-if="tableData.length > 0" class="rounded-bottom">
      <el-table
        :data="tableData"
        show-summary
        :summary-method="getSummaries"
        fit
        style="width: 100%"
      >
        <el-table-column
          label="Aging Date / Default Days"
          min-width="170"
          width="auto"
        >
          <template slot="header" slot-scope="scope">
            <span class="text-break">{{ scope.column.label }}</span>
          </template>
          <template slot-scope="scope">
            <p class="mb-0 top-line">{{ scope.row.trade_ref_aging_date }}</p>
            <p class="text-uppercase bottom-line mb-0">{{ scope.row.missed_pay_loan_statue }}</p>
          </template>
        </el-table-column>

        <el-table-column
          label="Referee/Tel"
          min-width="260"
          width="auto"
        >
          <template slot-scope="scope">
            <p class="mb-0 text-break top-line">{{ scope.row.trade_ref_referee_name }}</p>
            <p class="text-uppercase bottom-line mb-0">{{ scope.row.trade_ref_referee_tel }}</p>
          </template>
        </el-table-column>

        <el-table-column
          prop="trade_ref_outstanding_amt"
          label="Outstanding (RM)"
          width="200"
        >
          <template slot-scope="scope">
            <p class="top-line">{{ scope.row.trade_ref_outstanding_amt | moneyFormatter }}</p>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <div v-else class="bg-light p-3 text-center rounded-bottom">
      <p class="text-xs">No Trade References recorded</p>
    </div>
  </div>
  <div v-else>
      <div v-if="hasTradeReferenceData">
        <!-- E2: TRADE REFERENCE Summary -->
        <div class="trade-reference-section">
          <h4 style="margin-bottom: 20px;">E2: TRADE REFERENCE</h4>
          
          <!-- Summary Table -->
          <div class="summary-section">
            <h5>Summary</h5>
            <table class="trade-reference-table bordered" style="width:100%; margin-bottom: 30px;">
              <thead>
                <tr>
                  <th class="tr-header" style="width:40px;">No.</th>
                  <th class="tr-header">Referee</th>
                  <th class="tr-header">Account No.</th>
                  <th class="tr-header">Capacity</th>
                  <th class="tr-header">Statement Date</th>
                  <th class="tr-header">Default Amount (RM)</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(trade, index) in normalizedTradeReferenceData" :key="index">
                  <td class="tr-cell" style="text-align:center">{{ index + 1 }}.</td>
                  <td class="tr-cell">{{ trade.subject.ref_com_name }}</td>
                  <td class="tr-cell" style="text-align:center">{{ trade['@attributes'].account_no }}</td>
                  <td class="tr-cell" style="text-align:center">PERSONAL</td>
                  <td class="tr-cell" style="text-align:center">{{ trade.account_status.statement_date }}</td>
                  <td class="tr-cell" style="text-align:right">
                    {{ formatAmount(getDefaultAmount(trade.account_status.age)) }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <!-- Detailed Account Information -->
          <div v-for="(trade, index) in normalizedTradeReferenceData" :key="'detail-' + index" class="account-detail" style="margin-bottom: 40px; page-break-inside: avoid;">
            <h5 style="margin-bottom: 15px;">
              The following information are in relation to Account No: {{ trade['@attributes'].account_no }}
            </h5>

            <!-- 1. Relationship -->
            <div class="detail-section">
              <h6>1. Relationship</h6>
              <table class="trade-reference-table bordered" style="width:100%; margin-bottom: 20px;">
                <tbody>
                  <tr>
                    <td style="width: 200px; background: #e9e9e9;"><strong>Subject is</strong></td>
                    <td>{{ getSafeValue(trade.relationship.rel_type, 'CUSTOMER') }}</td>
                    <td style="width: 200px; background: #e9e9e9;"><strong>Relationship Start Date</strong></td>
                    <td>{{ getSafeValue(trade.relationship.rel_start_date, '13 February 2021') }}</td>
                  </tr>
                </tbody>
              </table>
            </div>

            <!-- 2. Aging Information -->
            <div class="detail-section">
              <h6>2. Aging Information As At Statement Date: {{ getSafeValue(trade.account_status.statement_date, '2022-04-05') }}</h6>
              <table class="trade-reference-table bordered" style="width:100%; margin-bottom: 20px;">
                <tbody>
                  <tr>
                    <td style="width: 200px; background: #e9e9e9;"><strong>Name of Debtor</strong></td>
                    <td>{{ getSafeValue(trade.account_status.debtor_name, 'NURALIZA BTE ALIAS (840830035838)') }}</td>
                  </tr>
                  <tr>
                    <td style="background: #e9e9e9;"><strong>Credit Terms</strong></td>
                    <td>{{ getSafeValue(trade.account_status.credit_terms, '30 Days') }}</td>
                  </tr>
                  <tr>
                    <td style="background: #e9e9e9;"><strong>Credit Limit (RM)</strong></td>
                    <td>{{ formatAmount(getSafeValue(trade.account_status.account_limit, '0.00')) }}</td>
                  </tr>
                  <tr>
                    <td style="background: #e9e9e9;"><strong>Account Status</strong></td>
                    <td>{{ getSafeValue(trade.account_status.account_status, 'Defaulter') }}</td>
                  </tr>
                  <tr>
                    <td style="background: #e9e9e9;"><strong>Account Reference No.</strong></td>
                    <td>{{ getSafeValue(trade.account_status.account_ref_no, trade['@attributes'].account_no) }}</td>
                  </tr>
                  <tr>
                    <td style="background: #e9e9e9;"><strong>Address</strong></td>
                    <td>{{ getSafeValue(trade.account_status.address, '-') }}</td>
                  </tr>
                  <tr>
                    <td style="background: #e9e9e9;"><strong>Nature of Debt</strong></td>
                    <td>{{ getSafeValue(trade.account_status.nature_of_debt, 'Dues outstanding') }}</td>
                  </tr>
                  <tr>
                    <td style="background: #e9e9e9;"><strong>Last Paid Amount (RM)</strong></td>
                    <td>{{ formatAmount(getSafeValue(trade.account_status.last_paid_amount, '0.00')) }}</td>
                  </tr>
                  <tr>
                    <td style="background: #e9e9e9;"><strong>Remarks</strong></td>
                    <td>{{ getSafeValue(trade.account_status.remarks, '-') }}</td>
                  </tr>
                </tbody>
              </table>

              <!-- Outstanding Default Table -->
              <h6 style="margin-top: 15px;">Outstanding Default</h6>
              <table class="trade-reference-table bordered" style="width:100%; margin-bottom: 20px;">
                <thead>
                  <tr>
                    <th class="tr-header">0-30 Days</th>
                    <th class="tr-header">31-60 Days</th>
                    <th class="tr-header">61-90 Days</th>
                    <th class="tr-header">91-120 Days</th>
                    <th class="tr-header">121-150 Days</th>
                    <th class="tr-header">151-180 Days</th>
                    <th class="tr-header">> 180 Days</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td class="tr-cell" style="text-align:center">{{ formatAmount(getSafeValue(trade.account_status.age.age_30, '0.00')) }}</td>
                    <td class="tr-cell" style="text-align:center">{{ formatAmount(getSafeValue(trade.account_status.age.age_60, '0.00')) }}</td>
                    <td class="tr-cell" style="text-align:center">{{ formatAmount(getSafeValue(trade.account_status.age.age_90, '0.00')) }}</td>
                    <td class="tr-cell" style="text-align:center">{{ formatAmount(getSafeValue(trade.account_status.age.age_120, '0.00')) }}</td>
                    <td class="tr-cell" style="text-align:center">{{ formatAmount(getSafeValue(trade.account_status.age.age_150, '0.00')) }}</td>
                    <td class="tr-cell" style="text-align:center">{{ formatAmount(getSafeValue(trade.account_status.age.age_180, '0.00')) }}</td>
                    <td class="tr-cell" style="text-align:center">{{ formatAmount(getSafeValue(trade.account_status.age.age_over_180, '0.00')) }}</td>
                  </tr>
                </tbody>
              </table>
              <p style="font-style: italic; margin-bottom: 20px;">
                The above was accurate as at the statement date indicate above.
              </p>

              <!-- Account Conduct -->
              <h6>Account Conduct</h6>
              <table class="trade-reference-table bordered" style="width:100%; margin-bottom: 20px;">
                <thead>
                  <tr>
                    <th class="tr-header">Not Provided</th>
                    <th class="tr-header">Excellent</th>
                    <th class="tr-header">Good</th>
                    <th class="tr-header">Satisfactory</th>
                    <th class="tr-header">Unsatisfactory</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td class="tr-cell" style="text-align:center">
                      <span v-if="getSafeValue(trade.account_status.account_rating_code) === '0'">X</span>
                    </td>
                    <td class="tr-cell" style="text-align:center">
                      <span v-if="getSafeValue(trade.account_status.account_rating_code) === '1'">X</span>
                    </td>
                    <td class="tr-cell" style="text-align:center">
                      <span v-if="getSafeValue(trade.account_status.account_rating_code) === '2'">X</span>
                    </td>
                    <td class="tr-cell" style="text-align:center">
                      <span v-if="getSafeValue(trade.account_status.account_rating_code) === '3'">X</span>
                    </td>
                    <td class="tr-cell" style="text-align:center">
                      <span v-if="getSafeValue(trade.account_status.account_rating_code) === '4'">X</span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <!-- 3. Returned Cheque History -->
            <div class="detail-section">
              <h6>3. Returned Cheque History</h6>
              <table class="trade-reference-table bordered" style="width:100%; margin-bottom: 20px;">
                <thead>
                  <tr>
                    <th class="tr-header">Cheque No.</th>
                    <th class="tr-header">Account No.</th>
                    <th class="tr-header">Bank</th>
                    <th class="tr-header">Amount (RM)</th>
                    <th class="tr-header">Date Returned</th>
                    <th class="tr-header">Reason</th>
                    <th class="tr-header">Cheque Issuer</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-if="hasReturnCheques(trade.return_cheques)">
                    <td colspan="7" class="tr-cell" style="text-align:center">
                      Data available
                    </td>
                  </tr>
                  <tr v-else>
                    <td colspan="7" class="tr-cell" style="text-align:center">
                      No Information Available
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <!-- 4. Reminders / Letter of Demand for Payment / General Remarks -->
            <div class="detail-section">
              <h6>4. Reminders / Letter of Demand for Payment / General Remarks</h6>
              <table class="trade-reference-table bordered" style="width:100%; margin-bottom: 20px;">
                <tbody>
                  <tr v-if="hasLegalAction(trade.legal_action)">
                    <td style="width: 70%;">{{ getSafeValue(trade.legal_action.reminder_letter.title) }}</td>
                    <td style="width: 30%; text-align:center">{{ getSafeValue(trade.legal_action.reminder_letter.date) }}</td>
                  </tr>
                  <tr v-else>
                    <td colspan="2" style="text-align:center">No Information Available</td>
                  </tr>
                </tbody>
              </table>
            </div>

            <!-- 5. CRA Comment -->
            <div class="detail-section">
              <h6>5. CRA Comment</h6>
              <table class="trade-reference-table bordered" style="width:100%; margin-bottom: 20px;">
                <tbody>
                  <tr>
                    <td style="text-align:center">
                      {{ hasCraComment(trade.cra_comment) ? 'Comment available' : 'No Information Available' }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <!-- 6. Subject's Comment -->
            <div class="detail-section">
              <h6>6. Subject's Comment</h6>
              <table class="trade-reference-table bordered" style="width:100%; margin-bottom: 20px;">
                <tbody>
                  <tr>
                    <td style="text-align:center">
                      {{ hasSubjectComments(trade.subject_comments) ? 'Comment available' : 'No Information Available' }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <!-- 7. Referee's Information -->
            <div class="detail-section">
              <h6>7. Referee's Information</h6>
              <table class="trade-reference-table bordered" style="width:100%; margin-bottom: 20px;">
                <tbody>
                  <tr>
                    <td style="width: 200px; background: #e9e9e9;"><strong>Referee</strong></td>
                    <td>{{ getSafeValue(trade.subject.ref_com_name) }}</td>
                  </tr>
                  <tr>
                    <td style="background: #e9e9e9;"><strong>Contact Name</strong></td>
                    <td>{{ formatContactName(getSafeValue(trade.referee_contact.contact_name)) }}</td>
                  </tr>
                  <tr>
                    <td style="background: #e9e9e9;"><strong>Address</strong></td>
                    <td>{{ getSafeValue(trade.referee_contact.contact_add, '-') }}</td>
                  </tr>
                  <tr>
                    <td style="background: #e9e9e9;"><strong>Telephone</strong></td>
                    <td>{{ getSafeValue(trade.referee_contact.contact_telno, '-') }}</td>
                  </tr>
                  <tr>
                    <td style="background: #e9e9e9;"><strong>Nature of Business</strong></td>
                    <td>{{ getSafeValue(trade.referee_contact.contact_nature_of_business, '-') }}</td>
                  </tr>
                  <tr>
                    <td style="background: #e9e9e9;"><strong>Remarks</strong></td>
                    <td>-</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>

      <!-- Empty State -->
      <div v-else class="bg-light p-3 text-center rounded-bottom">
        <p class="text-xs">No Trade References recorded</p>
      </div>
    </div>
  </modal>
</template>

<script>
import Modal from "@/components/Modal";
import { Table, TableColumn } from "element-ui";

export default {
  name: "TradeRefferencesModal",
  props: {
    tradeRefferences: {
      type: Array,
      default: () => []
    },
    tradeReferenceResp: {
      type: [Array, Object],
      default: () => []
    },
    show_trade_full_view: Boolean
  },
  components: {
    Modal,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn
  },
  data() {
    return {
      tableData: []
    };
  },
  computed: {
    show: {
      get() {
        return this.show_trade_full_view;
      },
      set(value) {
        this.$emit("update:show_trade_full_view", value);
      }
    },
    // New computed property to handle both arrays and objects
    hasTradeReferenceData() {
      if (Array.isArray(this.tradeReferenceResp)) {
        return this.tradeReferenceResp.length > 0;
      } else if (this.tradeReferenceResp && typeof this.tradeReferenceResp === 'object') {
        // Check if it's a non-empty object
        return Object.keys(this.tradeReferenceResp).length > 0;
      }
      return false;
    },
    
    // Normalize data to always be an array for consistent rendering
    normalizedTradeReferenceData() {
      if (Array.isArray(this.tradeReferenceResp)) {
        return this.tradeReferenceResp;
      } else if (this.tradeReferenceResp && typeof this.tradeReferenceResp === 'object') {
        // If it's a single object, wrap it in an array
        return [this.tradeReferenceResp];
      }
      return [];
    }
  },
  watch: {
    tradeRefferences: {
      immediate: true,
      handler(val) {
        this.tableData = val && val.length > 0 ? val : [];
      }
    }
  },
  methods: {
    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "Total";
          return;
        }
        const values = data.map(item => Number(item[column.property]));
        if (!values.every(value => isNaN(value))) {
          sums[index] = values
            .reduce((prev, curr) => {
              const value = Number(curr);
              return !isNaN(value) ? prev + curr : prev;
            }, 0)
            .toLocaleString(undefined, { minimumFractionDigits: 2 });
        } else {
          sums[index] = "";
        }
      });

      return sums;
    },
    getDefaultAmount(age) {
      // Determine default amount based on aging - prioritize the highest aging bucket
      if (parseFloat(age.age_over_180) > 0) return age.age_over_180;
      if (parseFloat(age.age_180) > 0) return age.age_180;
      if (parseFloat(age.age_150) > 0) return age.age_150;
      if (parseFloat(age.age_120) > 0) return age.age_120;
      if (parseFloat(age.age_90) > 0) return age.age_90;
      if (parseFloat(age.age_60) > 0) return age.age_60;
      if (parseFloat(age.age_30) > 0) return age.age_30;
      return '0.00';
    },
    // New method to safely handle contact_name
    formatContactName(contactName) {
      if (!contactName) return '-';
      
      if (Array.isArray(contactName)) {
        return contactName.length > 0 ? contactName.join(', ') : '-';
      }
      
      if (typeof contactName === 'string') {
        return contactName;
      }
      
      // Fallback for any other data type
      return String(contactName || '-');
    },
    // New method to format amounts to 2 decimal points
    formatAmount(value) {
      if (!value && value !== 0) return '0.00';
      
      const num = parseFloat(value);
      if (isNaN(num)) return '0.00';
      
      return num.toLocaleString('en-MY', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });
    },
    // New method to safely handle empty arrays and null/undefined values
    getSafeValue(value, fallback = '-') {
      if (Array.isArray(value)) {
        return value.length > 0 ? value[0] : fallback;
      }
      if (value === null || value === undefined || value === '') {
        return fallback;
      }
      return value;
    },
    // Check if return cheques has valid data
    hasReturnCheques(returnCheques) {
      if (!returnCheques) return false;
      if (Array.isArray(returnCheques)) {
        return returnCheques.length > 0;
      }
      return Object.keys(returnCheques).length > 0;
    },
    // Check if legal action has valid data
    hasLegalAction(legalAction) {
      if (!legalAction) return false;
      if (!legalAction.reminder_letter) return false;
      return this.getSafeValue(legalAction.reminder_letter.title) !== '-';
    },
    // Check if CRA comment has valid data
    hasCraComment(craComment) {
      if (!craComment) return false;
      if (Array.isArray(craComment)) {
        return craComment.length > 0;
      }
      return this.getSafeValue(craComment) !== '-';
    },
    // Check if subject comments has valid data
    hasSubjectComments(subjectComments) {
      if (!subjectComments) return false;
      if (Array.isArray(subjectComments)) {
        return subjectComments.length > 0;
      }
      return this.getSafeValue(subjectComments) !== '-';
    }
  }
};
</script>

<style scoped>
/* Styles for trade reference tables */
.trade-reference-table {
  border-collapse: collapse;
  width: 100%;
  font-family: inherit;
}
.trade-reference-table.bordered,
.trade-reference-table th,
.trade-reference-table td {
  border: 1px solid #000 !important;
}

/* New header styling for all trade reference tables */
.trade-reference-table th {
  background-color: #252938 !important;
  color: #fff !important;
  border: none !important;
  vertical-align: top !important;
  text-transform: none !important;
  font-size: 14px !important;
  font-weight: 400 !important;
  line-height: 19.5px !important;
  padding: 9px 12px !important;
  text-align: center !important;
}

.trade-reference-table td {
  background-color: #fff !important;
  color: #000 !important;
  padding: 8px 6px !important;
  text-align: left;
  font-size: 12px;
}
.trade-reference-table .tr-cell { 
  text-align: center; 
}
.trade-reference-table .text-break { 
  white-space: normal; 
}

.trade-reference-section {
  margin-top: 20px;
}
.summary-section {
  margin-bottom: 30px;
}
.account-detail {
  margin-bottom: 40px;
  page-break-inside: avoid;
}
.detail-section {
  margin-bottom: 25px;
}
.detail-section h6 {
  margin-bottom: 10px;
  font-weight: bold;
  color: #333;
}
</style>